import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import { Box } from '@eatclubapp/ec-component-library';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setPlatformAction } from '../../actions/platformAction';
import { platformMap } from '../../constants';
import { trackEvent } from '../../utils/analytics';
import { getAppConfig } from '../../constants/appConfig';

const PlatformPicker = ({ platform, setPlatform, restaurant }) => {
  const appConfig = getAppConfig();

  const platformOptions =
    !restaurant.platform || restaurant.platform === 'both'
      ? ['eatclub', 'whitelabel']
      : [restaurant.platform];

  const allowedPlatformOptions = platformOptions.filter((platformOption) => {
    if (appConfig.whiteLabelBlocked && platformOption === 'whitelabel') {
      return false;
    }
    return true;
  });

  // Don't show if there's just 1 option
  if (allowedPlatformOptions.length <= 1) {
    return <></>;
  }

  // Don't show for venues without whiteLabel
  if (restaurant.platform === '') {
    return <></>;
  }

  const handleSelect = (newValue) => {
    trackEvent('button_click: set_platform');

    setPlatform(newValue);
  };

  return (
    <Box
      style={{
        backgroundColor: '#F5F1EA',
        border: '1px solid #ECE7E0',
        borderRadius: '100px',
        height: 40,
      }}
    >
      {Object.values(platformMap).map((item) => (
        <Button
          key={item.name}
          color='white'
          onClick={() => handleSelect(item.value)}
          style={{
            background: item.value === platform ? '' : 'transparent',
            fontWeight: 400,
            height: 38,
          }}
          variant='contained'
        >
          {item.name}
        </Button>
      ))}
    </Box>
  );
};

PlatformPicker.propTypes = {
  platform: PropTypes.string.isRequired,
  setPlatform: PropTypes.func.isRequired,
  restaurant: PropTypes.shape({
    platform: PropTypes.string,
  }).isRequired,
};

const mapStateToProps = (state) => ({
  platform: state.platform.platform,
  restaurant: state.restaurantActive.restaurant,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ setPlatform: setPlatformAction }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PlatformPicker);
